/**
 * Hardcoded year range (newest first) for filter UIs (e.g. Search Documents, Upload Status).
 * Not used for content-management tree navigation.
 */
export const FILTER_YEAR_DROPDOWN_MIN = 1947;

export function getFilterYearNumbersForDropdown(referenceDate: Date = new Date()): number[] {
  const max = referenceDate.getFullYear();
  const min = FILTER_YEAR_DROPDOWN_MIN;
  if (!Number.isFinite(max)) return [min];
  if (max < min) return [max];
  const out: number[] = [];
  for (let y = max; y >= min; y -= 1) {
    out.push(y);
  }
  return out;
}

export function getFilterYearSelectOptions(referenceDate?: Date): { id: string; name: string }[] {
  return getFilterYearNumbersForDropdown(referenceDate).map((y) => ({
    id: String(y),
    name: String(y),
  }));
}
